export const POPULATE_SSR_AUCTIONS_NEAR_ME_HITS = 'la/domain/auctionsNearMe/POPULATE_SSR_AUCTIONS_NEAR_ME_HITS';

export const CLEAR_SSR_AUCTIONS_NEAR_ME_HITS = 'la/domain/auctionsNearMe/CLEAR_SSR_AUCTIONS_NEAR_ME_HITS';
